/*
                               (
                              (/(
                              (//(
                              (///(
                             (/////(
                             (//////(                          )
                            (////////(                        (/)
                            (////////(                       (///)
                           (//////////(                      (////)
                           (//////////(                     (//////)
                          (////////////(                    (///////)
                         (/////////////(                   (/////////)
                        (//////////////(                  (///////////)
                        (///////////////(                (/////////////)
                       (////////////////(               (//////////////)
                      (((((((((((((((((((              (((((((((((((((
                     (((((((((((((((((((              ((((((((((((((
                     (((((((((((((((((((            ((((((((((((((
                    ((((((((((((((((((((           (((((((((((((
                    ((((((((((((((((((((          ((((((((((((
                    (((((((((((((((((((         ((((((((((((
                    (((((((((((((((((((        ((((((((((
                    ((((((((((((((((((/      (((((((((
                    ((((((((((((((((((     ((((((((
                    (((((((((((((((((    (((((((
                   ((((((((((((((((((  (((((
                   #################  ##
                   ################  #
                  ################# ##
                 %################  ###
                 ###############(   ####
                ###############      ####
               ###############       ######
              %#############(        (#######
             %#############           #########
            ############(              ##########
           ###########                  #############
          #########                      ##############
        %######

        Powered by Knish.IO: Connecting a Decentralized World

Please visit https://github.com/WishKnish/KnishIO-Client-JS for information.

License: https://github.com/WishKnish/KnishIO-Client-JS/blob/master/LICENSE
*/
import Response from './Response.js'
import Wallet from '../Wallet.js'

/**
 * Response for ContinuID query
 */
export default class ResponseContinuId extends Response {
  /**
   * Class constructor
   *
   * @param {Query} query
   * @param {object} json
   */
  constructor ({
    query,
    json
  }) {
    super({
      query,
      json,
      dataKey: 'data.ContinuId'
    })
  }

  /**
   * Returns the ContinuID wallet
   *
   * @return {Wallet|null}
   */
  payload () {
    let wallet = null

    const continuId = this.data()

    if (continuId) {
      wallet = new Wallet({
        secret: null,
        token: continuId.tokenSlug
      })
      wallet.address = continuId.address
      wallet.position = continuId.position
      wallet.bundle = continuId.bundleHash
      wallet.batchId = continuId.batchId
      wallet.characters = continuId.characters
      wallet.pubkey = continuId.pubkey
      wallet.balance = String(continuId.amount != null ? continuId.amount : 0)
    }

    return wallet
  }
}
